export default __webpack_public_path__ + "static/BibleLandsTour-94e1ad1e15e3b554e8391bb8977356ca.jpg";